import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Guard that restricts access to admin-only routes
 * Redirects non-admin users to the customers page
 */
export const adminGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router: Router = inject(Router);

  // First check if authenticated
  if (!authService.isAuthenticated()) {
    return router.createUrlTree(['/login']);
  }

  // Then check if user is admin
  if (authService.isAdmin()) {
    return true;
  }

  // Redirect non-admin users to customers page
  return router.createUrlTree(['/customers']);
};
